import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const featuredImageUrls: Record<string, string> = {
  'prostate-anatomy-basics': 'https://readdy.ai/api/search-image?query=Scientific%20medical%20illustration%20of%20male%20pelvic%20anatomy%20showing%20prostate%20gland%20position%20and%20surrounding%20structures%2C%20clean%20educational%20diagram%20style%20with%20soft%20labels%2C%20neutral%20warm%20background%2C%20professional%20medical%20aesthetic&width=600&height=400&seq=article-anatomy-1&orientation=landscape',
  'prostate-nerve-system': 'https://readdy.ai/api/search-image?query=Scientific%20anatomical%20illustration%20of%20male%20pelvic%20nerve%20network%20highlighting%20prostate%20region%20and%20neural%20pathways%2C%20clean%20educational%20medical%20style%20with%20warm%20neutral%20background%2C%20professional%20diagram%20aesthetic&width=600&height=400&seq=article-anatomy-2&orientation=landscape',
  'hormones-and-prostate': 'https://readdy.ai/api/search-image?query=Scientific%20medical%20illustration%20of%20hormone%20molecular%20structure%20and%20male%20endocrine%20system%20diagram%2C%20clean%20educational%20style%20with%20warm%20neutral%20background%2C%20professional%20medical%20illustration&width=600&height=400&seq=article-anatomy-3&orientation=landscape',
  'prostate-and-sexual-response': 'https://readdy.ai/api/search-image?query=Scientific%20illustration%20of%20male%20sexual%20response%20cycle%20phases%20with%20prostate%20anatomy%20focus%2C%20clean%20medical%20educational%20diagram%20with%20warm%20neutral%20background%2C%20professional%20medical%20aesthetic&width=600&height=400&seq=article-anatomy-4&orientation=landscape',
  'external-prostate-massage': 'https://readdy.ai/api/search-image?query=Gentle%20illustration%20of%20perineum%20massage%20technique%20for%20male%20health%20with%20anatomical%20reference%2C%20clean%20soft%20educational%20style%20with%20warm%20neutral%20background%2C%20professional%20yet%20approachable%20medical%20aesthetic&width=600&height=400&seq=article-tech-1&orientation=landscape',
  'internal-prostate-massage': 'https://readdy.ai/api/search-image?query=Anatomical%20diagram%20showing%20internal%20prostate%20massage%20technique%20with%20clear%20medical%20illustration%20of%20male%20pelvic%20anatomy%2C%20clean%20educational%20style%20with%20warm%20neutral%20background%2C%20professional%20medical%20aesthetic&width=600&height=400&seq=article-tech-2&orientation=landscape',
};

export default function FeaturedArticles() {
  const featured = articles.slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              精选文章
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              由专业医学团队审核的深度科普内容
            </p>
          </div>
          <Link
            to="/category/anatomy"
            className="hidden sm:flex items-center text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {featured.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative h-40 md:h-44 overflow-hidden">
                <img
                  src={featuredImageUrls[article.slug] || featuredImageUrls['prostate-anatomy-basics']}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs rounded-full font-medium">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.publishDate}</span>
                  <span>{article.readTime} 分钟阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/anatomy"
            className="inline-flex items-center text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}